/* Uses only the Google tag installed by the Google & YouTube app.
 * Never collect form values or create a fallback gtag/dataLayer.
 */
(() => {
  'use strict';
  const marker = document.querySelector('[data-business-contact-tracking]');
  if (!marker || marker.dataset.initialized || window.Shopify?.designMode) return;
  marker.dataset.initialized = 'true';
  const form = document.getElementById(marker.dataset.formId);
  if (!form) return;

  const key = `hgt:business-contact:v1:${form.id}`;
  const historyKey = 'hgtBusinessContactSubmission';
  const maxAge = 30 * 60 * 1000;
  const read = () => {
    try {
      const record = JSON.parse(sessionStorage.getItem(key));
      return record && /^hgt-[a-f0-9-]{36}$/.test(record.id) &&
        Number.isFinite(record.createdAt) && Date.now() >= record.createdAt &&
        Date.now() - record.createdAt < maxAge ? record : null;
    } catch (_) { return null; }
  };
  const write = (record) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(record));
      return true;
    } catch (_) { return false; }
  };
  const clear = () => {
    try { sessionStorage.removeItem(key); } catch (_) { /* No tracking without storage. */ }
  };

  if (marker.dataset.success !== 'true' || marker.dataset.errors === 'true') {
    clear();
    // Native validation happens before submit. No click handler and no conversion here.
    form.addEventListener('submit', (event) => {
      if (event.defaultPrevented || !form.checkValidity()) return;
      try {
        const record = { id: `hgt-${crypto.randomUUID()}`, createdAt: Date.now(), status: 'pending' };
        if (!write(record)) return;
        // Honor cancellation by a later submit handler, without changing form behavior.
        queueMicrotask(() => {
          if (event.defaultPrevented && read()?.id === record.id) clear();
        });
      } catch (_) { clear(); }
    });
    return;
  }

  // This branch is reachable only with Shopify's posted_successfully? marker.
  // Bind this history entry to its submission so an old success page cannot consume
  // a later submission when the visitor returns to it.
  const record = read();
  if (!record || record.status !== 'pending') return;
  const boundId = history.state?.[historyKey];
  const navigation = performance.getEntriesByType('navigation')[0];
  if ((boundId && boundId !== record.id) || (!boundId && navigation?.type === 'back_forward')) return;
  try {
    history.replaceState({ ...history.state, [historyKey]: record.id }, '');
  } catch (_) { return; }

  let timer;
  let deadline;
  let finished = false;
  const stop = () => { clearTimeout(timer); };
  const attempt = () => {
    stop();
    if (finished) return;
    const current = read();
    if (!current || current.id !== record.id || current.status !== 'pending') return;
    // The app handles Consent Mode. Never set consent, load tags, or invent a queue.
    if (typeof window.gtag !== 'function') {
      if (Date.now() < deadline) timer = setTimeout(attempt, 500);
      return;
    }
    // Persist before invoking gtag: navigation/reload must not cause a second call.
    // A tag/ad-blocker failure can undercount; we deliberately do not retry a claimed ID.
    if (!write({ ...current, status: 'processed' })) return;
    finished = true;
    try {
      window.gtag('event', 'conversion', {
        send_to: 'AW-11001315175/3BaqCN358PECEOf-6v0o',
        transaction_id: current.id,
      });
    } catch (_) { /* Keep processed status to favor at-most-once delivery. */ }
  };
  const start = () => {
    deadline = Date.now() + 60 * 1000;
    attempt();
  };
  document.addEventListener('visitorConsentCollected', start);
  window.addEventListener('pageshow', start);
  window.addEventListener('pagehide', stop);
  start();
})();
